'use strict';

export const APPLY_TO_NONE = 'none';
export const APPLY_TO_STORE = 'store';
export const APPLY_TO_PRODUCTS = 'products';
export const APPLY_TO_COLLECTIONS = 'collections';
